import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useLanguage } from '../../context/LanguageContext';
import { useNavigate } from 'react-router-dom';
import { Newspaper, LogOut, Settings } from 'lucide-react';
import Button from '../common/Button';
import { motion } from 'framer-motion';

const Header: React.FC = () => {
  const { user, logout } = useAuth();
  const { labels } = useLanguage();
  const navigate = useNavigate();
  
  return (
    <header className="bg-white border-b border-dark-200 py-4 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center">
          <motion.div 
            className="flex items-center" 
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.3 }}
          >
            <div className="flex items-center">
              <div className="bg-primary-900 p-2 rounded-lg mr-3">
                <Newspaper className="h-6 w-6 text-white" />
              </div>
              <div>
                <h1 className="text-xl font-bold text-primary-900 tracking-tight">{labels.appTitle}</h1>
                <p className="text-xs text-primary-600 font-medium">AGENTDAGEN 2025</p>
              </div>
            </div>
          </motion.div>
          
          {user && (
            <motion.div 
              className="flex items-center"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.3 }}
            >
              <div className="flex items-center space-x-3">
                <Button
                  variant="ghost"
                  size="sm"
                  leftIcon={<Settings size={16} />}
                  onClick={() => navigate('/profile')}
                  className="text-primary-700 hover:text-primary-900 hover:bg-primary-50"
                >
                  <span className="hidden sm:inline">{labels.profile}</span>
                </Button>
                <Button
                  variant="outline"
                  size="sm"
                  leftIcon={<LogOut size={16} />}
                  onClick={logout}
                  className="border-primary-200 text-primary-700 hover:bg-primary-50 hover:border-primary-300"
                >
                  <span className="hidden sm:inline">{labels.logout}</span>
                </Button>
              </div>
            </motion.div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;